import { cn } from "@omni/utils/styles";

import { LogoutLinkContainer } from "@/components/Account/LogoutLink/logoutLink.container";
import { Divider } from "@/components/General/Divider/divider.component";
import { PageLinkProps } from "@/components/General/PageLinks/PageLink/pageLink.component";
import { PageLinks } from "@/components/General/PageLinks/pageLinks.component";
import "./accountButtonMenu.scss";

type Props = {
    links?: Array<PageLinkProps>;
};

const AccountButtonMenu = ({ links }: Props) => {
    return (
        <div className={cn("account-button-menu-wrapper")}>
            <Divider className={cn("tw:mb-4")} />
            <div className={cn("tw:mx-2")}>
                <PageLinks links={links} />
            </div>
            <Divider className={cn("tw:mb-2")} />
            <div className={cn("tw:mx-2")}>
                <LogoutLinkContainer className={cn("tw:no-underline!")} />
            </div>
        </div>
    );
};

export default AccountButtonMenu;
